import type { DriverResponse } from '@contracts/driver/DriverResponse';
import { LoadingSpinner } from '@src/common/components/LoadingSpinner';
import { Stack } from '@src/common/components/Stack';
import { useDriver } from '@src/driver/hooks/useDriver';
import type { ReactNode } from 'react';

export const DriverFormLoader = ({
  children,
  clientId,
  driverId,
}: {
  driverId: string;
  clientId: string;
  children: (data: { driver: DriverResponse }) => ReactNode;
}) => {
  const { driver, isLoading } = useDriver(clientId, driverId);

  if (isLoading)
    return (
      <Stack alignItems="center" justifyContent="center">
        <LoadingSpinner />
      </Stack>
    );

  if (!isLoading && !!driver) {
    return children({ driver });
  }
};
